import { IconPlaneTakeOff16 } from '@warp-ds/icons/react';

export const PrepackageSearchOriginOptions = [
    { value: '', label: 'Alle flyplasser i Norge', icon: <IconPlaneTakeOff16 /> },
    { value: 'OSL', label: 'Oslo, Gardermoen', icon: <IconPlaneTakeOff16 /> },
    { value: 'TRF', label: 'Sandefjord, Torp', icon: <IconPlaneTakeOff16 /> },
    { value: 'KRS', label: 'Kristiansand, Kjevik', icon: <IconPlaneTakeOff16 /> },
    { value: 'SVG', label: 'Stavanger, Sola', icon: <IconPlaneTakeOff16 /> },
    { value: 'HAU', label: 'Haugesund, Karmøy', icon: <IconPlaneTakeOff16 /> },
    { value: 'BGO', label: 'Bergen, Flesland', icon: <IconPlaneTakeOff16 /> },
    { value: 'AES', label: 'Ålesund, Vigra', icon: <IconPlaneTakeOff16 /> },
    { value: 'MOL', label: 'Molde, Årø', icon: <IconPlaneTakeOff16 /> },
    { value: 'KSU', label: 'Kristiansund, Kvernberget', icon: <IconPlaneTakeOff16 /> },
    { value: 'TRD', label: 'Trondheim, Værnes', icon: <IconPlaneTakeOff16 /> },
    { value: 'BOO', label: 'Bodø', icon: <IconPlaneTakeOff16 /> },
    { value: 'EVE', label: 'Harstad/Narvik, Evenes', icon: <IconPlaneTakeOff16 /> },
    { value: 'TOS', label: 'Tromsø, Langnes', icon: <IconPlaneTakeOff16 /> },
    { value: 'ALF', label: 'Alta', icon: <IconPlaneTakeOff16 /> },
    { value: 'GOT', label: 'Gøteborg, Landvetter', icon: <IconPlaneTakeOff16 /> },
];
